
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ExecutionResult, IEPurchasingConfiguration, IMetadataAction, PunchoutOrderRequestCriteria, PunchoutSetupRequestCriteria, RequisitionViewModel } from "@tylertech/tyler-api-types";

/**
 * EPurchasingService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class EPurchasingService {
    constructor(private readonly $apiService: ApiService) { }
    
    CreateRequisitionFromCart(cartId: string): Promise<ExecutionResult<RequisitionViewModel>> {
        return this.$apiService.sendAuth("IEPurchasingService/CreateRequisitionFromCart", cartId);
    }
    GetBuyerToken(userId: string): Promise<string> {
        return this.$apiService.sendAuth("IEPurchasingService/GetBuyerToken", userId);
    }
    SendPunchoutOrderRequest(criteria: PunchoutOrderRequestCriteria): Promise<ExecutionResult<string>> {
        return this.$apiService.sendAuth("IEPurchasingService/SendPunchoutOrderRequest", criteria);
    }
    SendPunchOutSetupCriteria(configuration: IEPurchasingConfiguration): Promise<ExecutionResult<string>> {
        return this.$apiService.sendAuth("IEPurchasingService/SendPunchOutSetupCriteria", configuration);
    }
    SendPunchOutSetupRequest(criteria: PunchoutSetupRequestCriteria): Promise<ExecutionResult<string>> {
        return this.$apiService.sendAuth("IEPurchasingService/SendPunchOutSetupRequest", criteria);
    }
    SendPurchaseOrderRequest(purchaseOrderIds: string[]): Promise<IMetadataAction> {
        return this.$apiService.sendAuth("IEPurchasingService/SendPurchaseOrderRequest", purchaseOrderIds);
    }
    SendPurchaseOrderRequestErrorList(purchaseOrderIds: string[]): Promise<string[]> {
        return this.$apiService.sendAuth("IEPurchasingService/SendPurchaseOrderRequestErrorList", purchaseOrderIds);
    }
    TransferCart(cartXml: string): Promise<string> {
        return this.$apiService.sendAuth("IEPurchasingService/TransferCart", cartXml);
    }
}
